/**
 * DATA LAYER: PREMIOS OVERLAY
 * Se encarga de la comunicación HTTP con la API de Premios.
 */

export const GetPremiosConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}premios/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetPremiosConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}premios/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const TogglePremiosVisibility = async (visible) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}premios/toggle-visibility`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visible })
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const CreatePremio = async (premio) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}premios`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(premio)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const UpdatePremio = async (id, premio) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}premios/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(premio)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const DeletePremio = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}premios/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SelectPremio = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}premios/select/${id}`, {
            method: 'POST'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};
